import { Application, Stage, WizardStagePayload } from '~/types/Application';
import { PaymentStagePayload } from '~/types/PaymentStagePayload';

export const getStagePayload = {
  wizard: (application: Application | undefined) => {
    if (!application) return undefined;
    if ((application.stagePayload as any)?.type === 'wizard') {
      return application.stagePayload as WizardStagePayload;
    }
    return undefined;
  },
  terminated: (application: Application | undefined) => {
    if (!application) return undefined;
    return application.stage === Stage.terminated ? application.stagePayload : undefined;
  },
  contract: (application: Application | undefined) => {
    if (!application) return undefined;
    return application.stage === Stage.contract ? application.stagePayload : undefined;
  },
  payment: (application: Application | undefined) => {
    if (!application) return undefined;
    if ((application.stagePayload as any)?.type === 'payment') {
      return application.stagePayload as PaymentStagePayload;
    }
    return undefined;
  },
  salesforceSoftDecline: (application: Application | undefined) => {
    if (!application) return undefined;
    return application.stage === Stage.salesforceSoftDecline ? application.stagePayload : undefined;
  },
};
